import React from 'react';
import { Form, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModeComponent from '../../ModeComponent';

export default class GenericMode extends ModeComponent {
  static propTypes = {
    cc: PropTypes.bool,
  };

  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'causeInput';

  schema = {
    causeInput: {
      label: 'Cause',
      multiline: true,
    },
    correctionInput: {
      label: 'Correction',
      multiline: true,
    },
  };

  state = {
    causeInput: {
      value: '',
      validationState: null,
    },
    correctionInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  render() {
    this.mode = this.props.mode;
    const showCC = this.props.cc;

    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {showCC ? (
              <>
                <div className="section-header">Prior Job</div>
                {this.validatedTextInput('causeInput')}
                {this.validatedTextInput('correctionInput')}
              </>
            ) : (
              <div style={{ fontSize: '16px', textAlign: 'center' }}>
                Press Process button to proceed with {this.props.mode}.
              </div>
            )}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
